/** Sparkline 이 보조기기에 읽어 줄 이름(그래프가 그림이라 글자가 없다) */
export const SPARKLINE_TEXT = {
  /** "매출 추이: 최근 4기간" · subject 가 없으면 "추이: 최근 4기간" */
  label: (count: number, subject?: string) =>
    `${subject ? `${subject} ` : ''}추이: 최근 ${count}기간`,
  /** 자료가 없을 때(기존 서비스처럼 빈 칸) */
  empty: (subject?: string) => `${subject ? `${subject} ` : ''}추이: 자료 없음`,
} as const;
